import React, { Suspense, useEffect, useState } from "react";
import AnnounceModal from "../../components/model/AnnounceModal";
import Enquiry from "../../components/enquiry/Enquiry";
import { AmerCenterData, SEOData } from "../../types/home";
import GoldenVisaSlider from "../../components/client/GoldenVisaSlider";
import Marquee from "../../components/marquee/Marquee";
import "../../css/slick-theme.css";
import "../../css/slick.css";
import "../../css/style.css";

import MetaHead from "../../components/metaHead/MetaHead";
import { useDispatch } from "react-redux";
import { setGlobalError, setGlobalLoading } from "../../store/slices/IdSlice";
import { getDataFromHomeApi, getJsonData } from "../../lib/api";
import PreLoader from "../../components/preloader/PreLoader";
import { useCart } from "../../hooks/useCart";
import "../../css/responsive.css";
const BannerServices = React.lazy(
  () => import("../../components/bannerServices/BannerServices")
);
const WhoWeAre = React.lazy(() => import("../../components/whoweare/WhoWeAre"));
const Experts = React.lazy(() => import("../../components/expert/Experts"));
const Services = React.lazy(() => import("../../components/services/Services"));
const Offers = React.lazy(() => import("../../components/Offers/Offers"));
const Clients = React.lazy(() => import("../../components/client/Clients"));

const Home = () => {
  const dispatch = useDispatch();
  const { getData } = useCart();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [mainServices, setMainServices] = useState([]);
  const [footBannerSlider, setfootBannerSlider] = useState([]);
  const [offers, setoffers] = useState([]);
  const [governmentPartners, setGovernmentPartners] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [data, setData] = useState<AmerCenterData>();
  const [metaData, setMetaData] = useState<SEOData>();
  const getDataFromJson = async () => {
    const result = await getJsonData(
      "https://goodhand.b-cdn.net/Assets/Home/Home.json"
    );
    if (result) {
      setMetaData(result.seo);
      setData(result);
      return true;
    } else {
      return false;
    }
  };

  const getDataFromApi = async () => {
    const response = await getDataFromHomeApi();

    if (response) {
      setMainServices(response.HomeData.mainServices);
      setfootBannerSlider(response.HomeData.footBannerSlider);
      setoffers(response.HomeData.offers);
      setGovernmentPartners(response.HomeData.MainLogo);
      setEmployee(response.HomeData.Employee);
      return true; // Indicate success
    } else {
      return false;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        setGlobalLoading(true);
        setIsError(false);

        const [jsonDataSuccess, apiDataSuccess] = await Promise.all([
          getDataFromJson(),
          getDataFromApi(),
          getData(),
        ]);
        if (!jsonDataSuccess || !apiDataSuccess) {
          setIsError(true);
          dispatch(setGlobalError(true));
        }
      } catch (error) {
        setIsError(true);
        console.error("Error during data fetching:", error);
        dispatch(setGlobalError(true));
        throw new Error("Failed to fetch e");
      } finally {
        setIsLoading(false);
        setGlobalLoading(false);
      }
    };

    fetchData();
  }, []);

  if (isError) {
    return null;
  }

  return (
    <>
      {/* <WebcamFrameSender /> */}

      {isLoading ? (
        <>
          <PreLoader />
        </>
      ) : (
        <div>
          <MetaHead metaData={metaData} />
          <Suspense>
            <BannerServices mainServices={mainServices} data={data?.section1} />
            <Enquiry />
            <Offers
              offers={offers}
              section8={data?.section8}
              isPackage={true}
            />
            <WhoWeAre
              governmentPartners={governmentPartners}
              section2={data?.section2}
            />
            <Marquee news={data?.section3.heading} />
            <Experts employee={employee} />
            <Services section5={data?.section5} section6={data?.["section6"]} />
            {/* <TouristVisa visitOffers={visitOffers} section4={data?.section4} /> */}
            <Clients section9={data?.section9} />
            <GoldenVisaSlider sliderData={footBannerSlider} />
            <AnnounceModal />
          </Suspense>
        </div>
      )}
    </>
  );
};

export default Home;
